// @ts-check
import React from 'react';
import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI('Provide Contacts for Your Institution'),
    'view:contactsInstructions': {
      'ui:description': (
        <div>
          <p>
            You will be asked to provide the contact information for both the
            financial representative and the certifying official of your
            institution.
          </p>
        </div>
      ),
    },
  },
  schema: {
    type: 'object',
    properties: {
      'view:contactsInstructions': {
        type: 'object',
        properties: {},
      },
    },
  },
};
